import { useTranslation } from '@spcc/core'
import {
  Table,
  TableBody,
  TableHead,
  TableHeader,
  TableRow,
} from '@spcc/uikit'
import { ShipmentRow } from './shipment-row'
import type { ShipmentsTableProps } from '../types'

export function ShipmentsTable({
  shipments,
  selectedRowId,
  showTenantColumn,
  onRowClick,
  onRowDoubleClick,
  isArabic,
}: ShipmentsTableProps) {
  const { t } = useTranslation()

  return (
    <div className="glass-card rounded-2xl overflow-hidden border border-border/50">
      <Table>
        <TableHeader>
          <TableRow className="border-border/40 hover:bg-transparent bg-muted/50">
            <TableHead className="text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider">
              {t('shipments.shipmentNumber')}
            </TableHead>
            {showTenantColumn && (
              <TableHead className="text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider">
                {t('common.tenant')}
              </TableHead>
            )}
            <TableHead className="text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider">
              {t('shipments.product')}
            </TableHead>
            <TableHead className="text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider">
              {t('shipments.origin')}
            </TableHead>
            <TableHead className="text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider">
              {t('shipments.destination')}
            </TableHead>
            <TableHead className="text-muted-foreground font-bold px-5 py-4 text-[11px] uppercase tracking-wider">
              {t('shipments.status')}
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {shipments.map((shipment) => (
            <ShipmentRow
              key={shipment.id}
              shipment={shipment}
              isSelected={selectedRowId === shipment.id}
              showTenantColumn={showTenantColumn}
              onClick={() => onRowClick(shipment)}
              onDoubleClick={() => onRowDoubleClick(shipment)}
              isArabic={isArabic}
            />
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
